import { useDispatch } from 'react-redux'
import { ThunkDispatch } from 'redux-thunk'

import { RootState, AppActionTypes } from '../store'

export type AppDispatch = ThunkDispatch<RootState, unknown, AppActionTypes>

export const useAppDispatch = () => useDispatch<AppDispatch>()
